import { createUseStyles } from 'react-jss'
import { trafficRedDark } from '../../../styles/const/colors'

export default createUseStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      marginTop: 16
    }
  },
  iconWrapper: {
    width: '100%',
    maxWidth: 17,
    marginRight: 13,
    display: 'flex',
    justifyContent: 'center'
  },
  successIcon: {
    height: 17,
    width: 17
  },
  errorIcon: {
    width: 10,
    height: 10,
    '& path': {
      fill: trafficRedDark
    }
  },
  loaderIcon: {
    height: 17,
    width: 17,
    '& .path': {
      stroke: `${theme.brandPrimary} !important`,
      strokeWidth: '5 !important'
    }
  },
  description: {
    fontSize: 14
  }
}))
